import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft, FiFileText, FiClock } from 'react-icons/fi';
import { ROUTES } from '../../app/routes';
import ValChoiceClassificationSearch from './ValChoiceClassificationSearch';
import ValChoiceClassificationHistory from './ValChoiceClassificationHistory';
import '../commissionscan/CommissionScan.css';
const ValChoiceClassificationPage: React.FC = () => {
    const navigate = useNavigate();
    const [view, setView] = useState<'search' | 'history'>('search');
    return (<div className="cs-page">
      <div className="cs-sidebar">
        <button className="cs-back-link" onClick={() => navigate(ROUTES.MARKETPLACE)}>
          <FiChevronLeft size={14}/>
          Back to Marketplace
        </button>
        <nav className="cs-nav">
          <button className={`cs-nav__item${view === 'search' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('search')}>
            <FiFileText size={15}/>
            Get Carrier Rating
          </button>
          <button className={`cs-nav__item${view === 'history' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('history')}>
            <FiClock size={15}/>
            History
          </button>
        </nav>
      </div>

      <div className={`cs-main${view === 'history' ? ' cs-main--history' : ''}`}>
        {view === 'history' ? (<ValChoiceClassificationHistory />) : (<ValChoiceClassificationSearch />)}
      </div>
    </div>);
};
export default ValChoiceClassificationPage;
